import { createReducer, on } from '@ngrx/store';
import * as actions from '../../actions';
import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { RequestPermission } from '@app-core/store/models/request-permision-counter.model';

export interface RequestPermissionListState
  extends EntityState<RequestPermission> {
  loaded: boolean;
  loading: boolean;
  error: any;
  count: number;
  params: any;
  statusFilter: string;
  filter: string;
  searchParams: any;
  advancedSearch: any;
}

export const adapter = createEntityAdapter<RequestPermission>({});

export const RequestPermissionListInitialState = adapter.getInitialState({
  loaded: false,
  loading: false,
  error: null,
  count: 0,
  params: null,
  statusFilter: null,
  filter: null,
  searchParams: null,
  advancedSearch: null,
});

export const requestPermissionListInitialStateListReducer = createReducer(
  RequestPermissionListInitialState,

  on(
    actions.getRequestPermission,
    (state, { params, statusFilter, filter }) => ({
      ...state,
      params: {
        ...params,
      },
      filter,
      statusFilter,
      loading: true,
    })
  ),

  on(actions.getRequestPermissionSuccess, (state, { requestlist, count }) =>
    adapter.setAll(requestlist, {
      ...state,
      loading: false,
      loaded: true,
      count,
    })
  ),

  on(actions.getRequestPermissionError, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: false,
    error: {
      url: payload.url,
      name: payload.name,
      message: payload.message,
    },
  }))
);

export const { selectAll } = adapter.getSelectors();
